import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/site';
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  id?: string;
  shake?: boolean;
  compact?: boolean;
};
export function CtaButton({
  label,
  sublabel = 'Only $27 · One-time payment · Instant access',
  id,
  shake = false,
  compact = false
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group relative flex w-full max-w-xl flex-col items-center justify-center rounded-2xl border-b-4 border-gold-dark bg-gold px-4 text-center text-navy outline-none transition-[transform,background-color] duration-150 ease-out hover:bg-[#FFCC3D] active:translate-y-0.5 focus-visible:ring-4 focus-visible:ring-sky/60 ${compact ? 'py-3' : 'py-4 md:py-5'} ${shake ? 'animate-cta-shake' : 'animate-cta-pulse'}`} data-id="element-33" data-mp="qkk6qtgfrazl">
      <span className={`flex items-center gap-2 font-display font-black uppercase leading-tight tracking-tight ${compact ? 'text-[13px] sm:text-base' : 'text-[14px] sm:text-lg md:text-xl'}`} data-id="element-34" data-mp="198p9bxlcwpwt">
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-35" data-mp="39yrcn93hbkgw" />
      </span>
      {sublabel && !compact && <span className="mt-1 text-[11px] font-semibold text-navy/75 sm:text-xs" data-id="element-36" data-mp="3jwxgvxcrd2ox">{sublabel}</span>}
    </a>;
}